import { forwardRef } from 'react'
import { LinkProps } from './props'
import { StyledLink } from './styles'

const Link = forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => (
    <StyledLink {...props} role="link" ref={ref} />
))

Link.displayName = 'Link'

export default Link

export { StyledLink }
